import { MdKeyboardArrowRight } from 'react-icons/md'
import { Box, Flex, type FlexProps } from '@chakra-ui/react'
import { type CategoryDTO } from 'ecosystem'
import { GrandLink, GrandText } from 'ui'
import { useSlideOutCategoriesDesktop } from './SlideOutCategoriesDesktopContext'

type NavListItemProps = {
  item: Partial<CategoryDTO>
  isLink?: boolean
  isSelected?: boolean
  isReversedLinkStyle?: boolean
} & FlexProps

export const NavListItem = ({
  item,
  isLink,
  isSelected,
  isReversedLinkStyle,
  ...props
}: NavListItemProps) => {
  const { customColors: colors, paths } = useSlideOutCategoriesDesktop()
  const bgActive = colors?.itemBgActive || 'gray.300'
  const bgHover = colors?.itemBg || 'gray.200'

  if (isLink || !item.subCategories?.length) {
    return (
      <Flex fontSize="sm" py={1} {...props}>
        <GrandLink
          _hover={{
            textDecoration: isReversedLinkStyle ? 'none' : 'underline'
          }}
          href={`${paths.categories}/${item.slug}`}
          textDecoration={isReversedLinkStyle ? 'underline' : 'none'}
        >
          {item.name}
        </GrandLink>
      </Flex>
    )
  }

  return (
    <Box
      w="100%"
      {...(isSelected
        ? {
            position: 'sticky',
            top: -6,
            bottom: -6
          }
        : {})}
    >
      <Flex
        _hover={{
          bg: isSelected ? bgActive : bgHover,
          cursor: isSelected ? 'default' : 'pointer'
        }}
        alignItems="center"
        bg={isSelected ? bgActive : ''}
        borderRadius="2xl"
        fontSize="sm"
        justifyContent="space-between"
        mx={-3}
        px={3}
        py={1}
        w="calc(100% + var(--chakra-space-6))"
        {...props}
      >
        <GrandText>{item.name}</GrandText>

        <Box fontSize="lg">
          <MdKeyboardArrowRight />
        </Box>
      </Flex>
    </Box>
  )
}
